// extracted by mini-css-extract-plugin
export default {"content":"toa-z","title":"uoa-z","subTitle":"voa-z","banner":"woa-z","productCardOverride":"xoa-z"};